var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.LayoutList,
    [
      _vm.resource
        ? _c(
            "template",
            { slot: "header" },
            [
              _c("h1", [_vm._v(_vm._s(_vm.resource.activityName || " "))]),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "btn btn--primary",
                  attrs: {
                    to: {
                      name: "create-activity",
                      params: {
                        event_id: _vm.resource.eventId,
                        start: _vm.resource.end,
                      },
                    },
                  },
                },
                [_vm._v("\n                Add Another\n            ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--danger",
                  on: {
                    click: function ($event) {
                      return _vm.showDeleteModal()
                    },
                  },
                },
                [_vm._v("\n                Delete Activity\n            ")]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "btn btn--outline",
                  attrs: {
                    to: {
                      name: "edit-activity",
                      params: {
                        event_id: _vm.resource.eventId,
                        id: _vm.resource.activity_id,
                      },
                    },
                  },
                },
                [_vm._v("\n                Edit\n            ")]
              ),
              _vm._v(" "),
              _vm.resource.activityTypeFormatted ===
                _setup.ActivityTypes.MEALS || _vm.resource.registrable === true
                ? _c("div", [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn--activity-registrations btn--primary",
                        on: {
                          click: function ($event) {
                            return _vm.createRegistrations()
                          },
                        },
                      },
                      [_vm._v("Create Registrations")]
                    ),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("section", { staticClass: "activity-info" }, [
        _c("ul", { staticClass: "grid post-details" }, [
          _vm.resource.start
            ? _c("li", { staticClass: "col-12 col-md-2 col-bleed-y detail" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Start Date")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.resource.start.displayDate) +
                      ", " +
                      _vm._s(_vm.resource.start.displayTime)
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.end
            ? _c("li", { staticClass: "col-12 col-md-2 col-bleed-y detail" }, [
                _c("span", { staticClass: "label" }, [_vm._v("End Date")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.resource.end.displayDate) +
                      ", " +
                      _vm._s(_vm.resource.end.displayTime)
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.activityLocation
            ? _c("li", { staticClass: "col-12 col-md-2 col-bleed-y detail" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Location")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.resource.activityLocation))]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.activityRoom
            ? _c("li", { staticClass: "col-12 col-md-2 col-bleed-y detail" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Room")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.resource.activityRoom))]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.activityTypeFormatted
            ? _c("li", { staticClass: "col-12 col-md-2 col-bleed-y detail" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Activity Type")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.resource.activityTypeFormatted)),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "location-info" }, [
        _c("ul", { staticClass: "grid post-details" }, [
          _vm.resource.rating
            ? _c("li", { staticClass: "col-12 col-md-2 col-bleed-y detail" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Rating")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.resource.rating))]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.website
            ? _c("li", { staticClass: "col-12 col-md-2 col-bleed-y detail" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Website")]),
                _vm._v(" "),
                _c("span", [
                  _c(
                    "a",
                    { attrs: { href: _vm.resource.website, target: "_blank" } },
                    [_vm._v("Visit Website")]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.phoneNumber
            ? _c("li", { staticClass: "col-12 col-md-2 col-bleed-y detail" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Phone Number")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.resource.phoneNumber) +
                      "\n                    "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.directionUrl
            ? _c("li", { staticClass: "col-12 col-md-2 col-bleed-y detail" }, [
                _c("span", { staticClass: "label" }, [_vm._v("Directions")]),
                _vm._v(" "),
                _c("span", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.resource.directionUrl,
                        target: "_blank",
                      },
                    },
                    [_vm._v("Get Directions")]
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "grid" }, [
        _c("div", { staticClass: "col-12 col-md-8" }, [
          _vm.resource.activityDescription
            ? _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "header" }, [_vm._v("Description")]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(_vm.resource.activityDescription),
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.activityBackgroundImage
            ? _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "header" }, [
                  _vm._v("Background Image"),
                ]),
                _vm._v(" "),
                _c("img", {
                  staticStyle: { "max-width": "100%" },
                  attrs: {
                    src: _vm.resource.activityBackgroundImage,
                    alt: "Background Image",
                  },
                }),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.resource.chairPeople
          ? _c("div", [
              _c("h2", [_vm._v("Chair People")]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "grid" },
                _vm._l(_vm.resource.chairPeople, function (person) {
                  return _c("li", { staticClass: "col-12" })
                }),
                0
              ),
            ])
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }